import { Yup } from 'cng-web-lib'
import Namespace from 'src/constants/locale/Namespace'
import {
  constants,
} from 'cng-web-lib'

const {
  locale: {
    key: {
      CommonValidationMessageKeys,
    },
  },
} = constants

function makeValidationSchema(translate) {
  let requiredMessage = translate(
    Namespace.COMMON_VALIDATION_MSG,
    CommonValidationMessageKeys.REQUIRED
  )
  let dateTypeErrorMessage = translate(
    Namespace.COMMON_VALIDATION_MSG,
    CommonValidationMessageKeys.DATE_TYPE_ERROR
  )

  return Yup.object({
    _lineItemId: Yup.number().required(requiredMessage),
    scheduleItemId: Yup.number(),
    scheduleCorpid: Yup.string().nullable(),
    scheduleQuantity: Yup.number().max(30, "Max length allowed is 30.").nullable(),
    scheduleQuantityUom: Yup.string().max(2, "Max length allowed is 2.").nullable(),
    distributionPoNumber: Yup.string().max(45, "Max length allowed is 45.").nullable(),
    distributionCenter: Yup.string().max(20, "Max length allowed is 20.").nullable(),
    scheduleDate: Yup.date().validFormat().nullable(),
  })
}

export default makeValidationSchema
